/**
 * Layout classes for setup-style pages (Setup, Question Configuration).
 *
 * These mirror the portal work pages so a `DashboardTable` rendered in a tab
 * inherits a bounded height and owns its own scrolling. Without a bounded
 * ancestor the table's `lockToViewport` flex chain never resolves and the rows
 * either overflow the page or collapse.
 */

/** Page root: fills the remaining portal viewport height and clips overflow. */
export const SETUP_PAGE_SHELL_CLASS =
  "flex flex-1 min-h-0 w-full min-w-[768px] flex-col gap-6 overflow-hidden";

/** `Tabs` root: passes the bounded height down to the active tab. */
export const SETUP_PAGE_TABS_CLASS = "flex min-h-0 flex-1 flex-col min-w-0";

/** Page chrome (tab bar, header, blurb) that must keep its natural height. */
export const SETUP_PAGE_CHROME_CLASS = "shrink-0";

/** `TabsContent` for a tab whose body is a list/table that scrolls internally. */
export const SETUP_PAGE_LIST_TAB_CLASS =
  "mt-6 flex min-h-0 flex-1 flex-col min-w-0 overflow-hidden";

/**
 * `TabsContent` for a list tab that renders the page chrome (title, blurb)
 * inside its own scroller so the chrome scrolls away with the rows. The top
 * margin is dropped because the chrome, not the tab, now leads the pane.
 */
export const SETUP_PAGE_LIST_TAB_HOSTS_CHROME_CLASS =
  "flex min-h-0 flex-1 flex-col min-w-0 overflow-hidden";

/** `TabsContent` for a tab whose body is a form or report that scrolls as a page. */
export const SETUP_PAGE_SCROLL_TAB_CLASS =
  "mt-6 min-h-0 flex-1 overflow-y-auto";
